import { AllUsers, Department } from '@/types/user';
import { request } from 'umi';

export interface UserInfo {
  ID: string;
  departmentRef: { ID: string; name: string; isMain: boolean }[];
  fullName: string;
  name: string;
  employeeNo: string;
}
export const getOrganizations = (): Promise<{
  organization: Department;
}> => {
  return request('/organizations');
};

// 获取企微用户
export const getAllWxUsers = (): Promise<AllUsers> => {
  return request('/users/wx');
};

export const requestUserInfo = () => request<UserInfo>(`/users/userInfo`);

// 企业微信登录
export const requestWxLogin = (data: {
  code: string;
}): Promise<{
  token: string;
}> =>
  request('/users/wxLogin/token', {
    method: 'post',
    data,
    skipErrorHandler: true,
  });

// 飞书登录
export const requestFeishuLogin = (data: {
  code: string;
}): Promise<{
  token: string;
  userID: string;
  username: string;
  feishuUserID: string;
  feishuUnionID: string;
  employeeNo: string;
}> =>
  request('/users/feishuLogin/token', {
    method: 'post',
    data,
    skipErrorHandler: true,
  });
